import React, { useState, useRef } from 'react';
import { Card } from '../core/Card';
import { List } from '../core/List';
import { useNavigate } from 'react-router-dom';
import { DataObjectContainer } from '../dataObjects/DataObjectContextManager';
import { PageableList } from '../dataObjects/BoundControls';
import { ApiDataAccess } from '../infrastructure/ApiDataAccess';
import { Popup } from '../core/Popup';
import { XSquare } from 'react-feather';


import axios from 'axios';
import './PreflightView.css'


export const PreflightView = (props) => {
    const navigate = useNavigate();

    return (
        <div>
            <button className='btn btn-square btn-tertiary-outline' onClick={() => { navigate('/preflight/audit') }}>Audit</button>
            <button className='btn btn-square btn-tertiary-outline' onClick={() => { navigate('/preflight/profiles') }}>Profiles</button>
        </div>
    );
}



export const PreflightProfileView = (props) => {
    const navigate = useNavigate();

    return (
        <Card title='Profiles' className="profiles" subtitle='Manage Profiles used for Pre-Flighting'>
            <FileUpload />
        </Card>
    );
}



export const FileUpload = ({ onFileReceived, onFileUpload }) => {

    const list = useRef(null);
    
    const handleFileChange = async (e) => {
        var file = e.target.files[0];

        const formData = new FormData();
        formData.append('myFile', file); // 'myFile' must match the backend parameter name

        try {
            await axios.post('/api/profile', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
            list.current.refresh();
        }
        catch (error)
        {
            console.error("Error uploading file", error);
        }

    };

    const showUploadDialog = () => {

        if (onFileUpload) {
            onFileUpload();
        }
        const myButton = document.getElementById('uploadButton');
        myButton.click();
    }

    return (
        <div className='fileUpload'>
            <input id='uploadButton' type="file" accept=".ppp" onChange={handleFileChange} />
            <button className='btn btn-primary' onClick={() => { showUploadDialog() }}>Upload Profile</button>

            <List
                controller='api/profile'
                action=''
                ref={list}
                headers={[
                    { column: 'id', title: 'Id', sortable: false },
                    { column: 'name', title: 'Name', sortable: false },
                    { column: 'createDate', title: 'Create Date', sortable: false },
                ]}
                onRenderRow={(column, item, header) => {
                    switch (column) {
                        case 'name':
                            return (<a href={`/api/profile/${item['name']}`}>{item[column]}</a>)
                        default:
                            if (item[column] != null) {
                                return (<span>{item[column]}</span>);
                            }
                    }
                }}
            />


        </div>
    );
};


export const PreflightAuditView = () => {

    const context = useRef(null);
    const list = useRef(null);
    const reportPopup = useRef(null);
    const [report, setReport] = useState(null);

    const onRowSelected = async (item) => {
        console.log(item);
        var dataAccess = new ApiDataAccess('/api/preflight')

        var response = await dataAccess.get(`/order/${item.orderNumber}/Sku/${item.skuId}/details`)
        
        if (response && response.report) {
            setReport(response.report)
            reportPopup.current.show();
        }
    }


    return (
        <Card title='Audit'>

            <Popup ref={reportPopup}>
                <ReportPopupContent report={report} popup={reportPopup.current} />
            </Popup>

            <DataObjectContainer ref={context} dataObjectName={'preflightAuditDataObject'} >

                <PageableList pageSize={100} ref={list} 
                    onRenderHeaderRow={() => {
                        return (
                            <>
                                <div className='row caption' >
                                    <div className='cell'>Job Id</div>
                                    <div className='cell'>Order</div>
                                    <div className='cell'>Sku</div>
                                    <div className='cell'>Status</div>
                                    <div className='cell'>Date</div>
                                </div>
                            </>
                        )
                    }}
                    onRenderRow={(key, item, references) => {
                        return (
                            <div className={item.responseStatus == 'Failed' ? 'row clickable background-error color-white' : 'row clickable'} key={`row${key}`} onClick={() => {onRowSelected(item)}  }>
                                <div className='cell'>{item.jobId}</div>
                                <div className='cell'>{item.orderNumber}</div>
                                <div className='cell'>{item.skuId}</div>
                                <div className='cell'>{item.processingStatus}</div>
                                <div className='cell'>{item.createDate}</div>
                            </div>
                        )
                    }} />

            </DataObjectContainer>
        </Card>
    )
}


export const ReportPopupContent = ({report, popup}) => {

    console.log('REPORT', report);

    const getErrors = () => {
        var result = [];        
        if (report && report.errors && report.errors.items) {
            report.errors.items.forEach(item => {
                result.push(item.message);
            });
        }
        else {
            result.push('No Errors');
        }
        return result;
    }

    const getWarnings = () => {
        var result = [];
        if (report && report.warnings && report.warnings.items) {
            report.warnings.items.forEach(item => {
                result.push(item.message);
            });
        }
        else {
            result.push('No Warnings');
        } 
        return result;
    }

    const getInformations = () => {
        var result = [];
        if (report && report.informations && report.informations.items) {
            report.informations.items.forEach(item => {
                result.push(item.message);
            });
        }
        else {
            result.push('No Information');
        }
        return result;
    }


    return (
        <div className='reportPopupContent'>

            <div className='topSection'>
                <div className='left'></div>
                <div className='center'><h4>Report Details</h4></div>
                <div className='right'><XSquare className='icon btn-close clickable' onClick={() => { popup.close() }} /></div>
            </div>

            <div className='contentSection'>
                <p>Errors</p>
                <ul>
                {
                        getErrors().map((item, idx) => {
                        return (
                            <li key={`error${idx}`}>{item}</li>
                        )
                    })
                }
                </ul>

                <p>Warnings</p>
                <ul>
                    {
                        getWarnings().map((item, idx) => {
                            return (
                                <li key={`warnings${idx}`}>{item}</li>
                            )
                        })
                    }
                </ul>

                <p>Information</p>
                <ul>
                    {
                        getInformations().map((item, idx) => {
                            return (
                                <li key={`information${idx}`}>{item}</li>
                            )
                        })
                    }
                </ul>


                <p>Details</p>
                <pre className='details'>
                    {JSON.stringify(report, null, 2)}
                </pre>
            </div>

            <div className='footerSection'>
                <button className='btn btn-primary btn-modal full' onClick={() => { popup.close(); }}>Close</button>
            </div>
        </div>
    )
}